export const CONSTANTS = {
  ATTRIBUTES: {
    STOCK_AVAILABLE: 'StockAvailable',
    STOCK_SOON: 'StockSoon',
    STOCK_LATER: 'StockLater',
    STOCK_SOLD_OUT: 'StockSoldOut',
  },
  STATUS: {
    AVAILABLE: 'available',
    FEW_AVAILABLE: 'few-available',
    MAYBE_AVAILABLE: 'maybe-available',
    AVAILABLE_SOON: 'available-soon',
    AVAILABLE_LATER: 'available-later',
    AVAILABLE_FROM: 'available-from',
    SOLD_OUT: 'sold-out',
    NOTAVAILABLE: 'notavailable',
  },
}

export const AVAILABILITY_TO_ATTRIBUTE_CODE_MAPPING = {
  [CONSTANTS.STATUS.AVAILABLE]: CONSTANTS.ATTRIBUTES.STOCK_AVAILABLE,
  [CONSTANTS.STATUS.MAYBE_AVAILABLE]: CONSTANTS.ATTRIBUTES.STOCK_AVAILABLE,
  [CONSTANTS.STATUS.FEW_AVAILABLE]: CONSTANTS.ATTRIBUTES.STOCK_AVAILABLE,
  [CONSTANTS.STATUS.AVAILABLE_SOON]: CONSTANTS.ATTRIBUTES.STOCK_SOON,
  [CONSTANTS.STATUS.AVAILABLE_LATER]: CONSTANTS.ATTRIBUTES.STOCK_LATER,
  [CONSTANTS.STATUS.AVAILABLE_FROM]: CONSTANTS.ATTRIBUTES.STOCK_SOLD_OUT,
  [CONSTANTS.STATUS.SOLD_OUT]: CONSTANTS.ATTRIBUTES.STOCK_SOLD_OUT,
  [CONSTANTS.STATUS.NOTAVAILABLE]: CONSTANTS.ATTRIBUTES.STOCK_SOLD_OUT,
}

export const STOCK_ATTRIBUTE_ORDER = [
  CONSTANTS.ATTRIBUTES.STOCK_AVAILABLE,
  CONSTANTS.ATTRIBUTES.STOCK_SOON,
  CONSTANTS.ATTRIBUTES.STOCK_LATER,
  CONSTANTS.ATTRIBUTES.STOCK_SOLD_OUT,
]

export default {
  ...CONSTANTS,
  AVAILABILITY_TO_ATTRIBUTE_CODE_MAPPING,
  STOCK_ATTRIBUTE_ORDER,
}
